import authConfig from '../../auth-config.json';
import * as wellKnown from '../../well-known.json';
import apiConfig from '../../api-config.json';

interface AuthApi {
  baseUrl: string;
}

interface AuthApiConfig {
  api: AuthApi;
}

export const environment = {
  production: false,
  auth: {
    clientId: authConfig.clientId,
    authority: authConfig.authority,
    wellKnown: JSON.stringify(wellKnown),
    redirectUri: authConfig.redirectUri,
    scopes: authConfig.scopes,
    protectedResources: authConfig.protectedResources,
  },
  api: (apiConfig as AuthApiConfig).api,
};
